import type { ReactNode } from "react";
import { cn } from "@/frontend/lib/utils";

type Props = {
  children: ReactNode;
  /** Override the content width. Defaults to 90% of the page, floored and capped. */
  contentClassName?: string;
};

/**
 * 90% of the page so the column flexes with the viewport, floored at 520px so
 * the two-column grids never crush and capped at 780px so it does not sprawl.
 * The floor yields to the page on a narrow phone, where 520px would overflow.
 */
const CONTENT_WIDTH = "w-[90%] min-w-[min(32.5rem,100%)] max-w-[48.75rem]";

/**
 * One full page for a signup step, with the brand in a page header instead of a
 * side panel and the step's content centred under it. Sign in keeps
 * `SplitGridLayout`, so this is only for the persona and workspace setup steps.
 */
export function OnboardingPageLayout({ children, contentClassName }: Props) {
  return (
    <div className="flex min-h-svh flex-col bg-background">
      <div className="flex items-center gap-2.5 px-5 py-5 text-base font-semibold md:px-6">
        <img src="/assets/medblocks.webp" alt="" className="size-8 object-contain" />
        Medblocks Platform
      </div>

      <div className="flex flex-1 items-center justify-center px-4 pb-6 md:px-6">
        <div className={cn(contentClassName ?? CONTENT_WIDTH)}>{children}</div>
      </div>
    </div>
  );
}
